import { useDownloadableProductOrders } from '@/data/order';
import { useMe } from '@/data/user';
import { useCallback, useMemo } from 'react';

function useInSuccessfulOrders(productId: number | string) {
  const { downloadableFiles, isLoading } = useDownloadableProductOrders();
  const { me } = useMe();

  const fileableIds = useMemo(
    () =>
      downloadableFiles
        .filter((v) => v.order.payment_status === 'payment-success')
        .map((file) => file.file.fileable_id),
    [downloadableFiles]
  );

  const inOrders = useCallback(
    (productId: number | string) => {
      return fileableIds.includes(productId);
    },
    [downloadableFiles]
  );

  const file = useMemo(
    () =>
      downloadableFiles.find(
        (v) =>
          v.order.payment_status === 'payment-success' &&
          v.file.fileable_id === productId
      ),
    [downloadableFiles]
  );

  return {
    inOrders,
    in_orders: inOrders(productId) || me?.name === 'admin', // TODO: make this better lol
    isLoadingOrders: isLoading,
    file,
  };
}

export { useInSuccessfulOrders };
